import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { registerQuery, useQuery } from 'data-fetching-client';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { api } from '../utils/api';
import { PORTAL_DATA_PATH } from '../../api/paths';
const GET_PORTAL_DATA_KEY = 'getPortalData';
export const getPortalData = async () => {
  const response = await api(PORTAL_DATA_PATH);
  return response.json();
};
const GET_PORTAL_DATA = registerQuery({
  fieldName: GET_PORTAL_DATA_KEY,
  fetcher: getPortalData
});
export const usePortalData = () => {
  const _useQuery = useQuery(GET_PORTAL_DATA),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data[GET_PORTAL_DATA_KEY],
    refetch,
    loading
  }, rest);
};
export const useConfiguredTicketProperties = () => {
  const {
    data
  } = usePortalData();
  return data === null || data === void 0 ? void 0 : data.configuredTicketProperties;
};